import {Button} from "@pg-design/button-module";
import {TextVariantUnionType} from "@pg-design/text-module";

import {IInfoData} from "../types/IInfoData";

const howSearchWorksTitleVariant: TextVariantUnionType = "headline_6";
const howSearchWorksCopyVariant: TextVariantUnionType = "info_txt_1";

export const howSearchWorksInfoData: IInfoData[] = [
    {
        title: "Wypełnij ankietę oczekiwań on-line",
        titleVariant: howSearchWorksTitleVariant,
        copy: "W kilku prostych krokach zbierzemy informacje o interesujących Cię lokalizacjach i parametrach Twojego wymarzonego M.",
        copyVariant: howSearchWorksCopyVariant,
        additionalComponent: (onClick: () => void) => (
            <Button variant="filled_primary" type="button" fullWidth onClick={onClick}>
                Wypełnij ankietę
            </Button>
        )
    },
    {
        title: "Oczekuj na kontakt konsultanta",
        titleVariant: howSearchWorksTitleVariant,
        copy: "Nasz konsultant skontaktuje się z Tobą w przeciągu 24 godzin, zapyta o Twoje dodatkowe szczególne preferencje i wróci do Ciebie z pierwszymi ofertami mieszkań.",
        copyVariant: howSearchWorksCopyVariant
    },
    {
        title: "Poproś o wsparcie w pozyskaniu kredytu",
        titleVariant: howSearchWorksTitleVariant,
        copy: "Współpracujemy z ponad 20 bankami w Polsce , a nasi konsultanci kredytowi będą gotowi by wesprzeć Cię w procesie skutecznego pozyskania kredytu hipotecznego.",
        copyVariant: howSearchWorksCopyVariant
    },
    {
        title: "Zapytaj o więcej",
        titleVariant: howSearchWorksTitleVariant,
        copy: "W każdej chwili możesz poprosić konsultanta o merytoryczne wsparcie w kwestiach poszukiwania i zakupu nieruchomości. Nasi eksperci podpowiedzą Ci na co zwrócić uwagę w ofertach i jak skutecznie negocjować z deweloperem.",
        copyVariant: howSearchWorksCopyVariant
    }
];
import {Button} from "@pg-design/button-module";
import {TextVariantUnionType} from "@pg-design/text-module";

import {IInfoData} from "../types/IInfoData";

const howSearchWorksTitleVariant: TextVariantUnionType = "headline_6";
const howSearchWorksCopyVariant: TextVariantUnionType = "info_txt_1";

export const howSearchWorksInfoData: IInfoData[] = [
    {
        title: "Wypełnij ankietę oczekiwań on-line",
        titleVariant: howSearchWorksTitleVariant,
        copy: "W kilku prostych krokach zbierzemy informacje o interesujących Cię lokalizacjach i parametrach Twojego wymarzonego M.",
        copyVariant: howSearchWorksCopyVariant,
        additionalComponent: (onClick: () => void) => (
            <Button variant="filled_primary" type="button" fullWidth onClick={onClick}>
                Wypełnij ankietę
            </Button>
        )
    },
    {
        title: "Oczekuj na kontakt konsultanta",
        titleVariant: howSearchWorksTitleVariant,
        copy: "Nasz konsultant skontaktuje się z Tobą w przeciągu 24 godzin, zapyta o Twoje dodatkowe szczególne preferencje i wróci do Ciebie z pierwszymi ofertami mieszkań.",
        copyVariant: howSearchWorksCopyVariant
    },
    {
        title: "Poproś o wsparcie w pozyskaniu kredytu",
        titleVariant: howSearchWorksTitleVariant,
        copy: "Współpracujemy z ponad 20 bankami w Polsce , a nasi konsultanci kredytowi będą gotowi by wesprzeć Cię w procesie skutecznego pozyskania kredytu hipotecznego.",
        copyVariant: howSearchWorksCopyVariant
    },
    {
        title: "Zapytaj o więcej",
        titleVariant: howSearchWorksTitleVariant,
        copy: "W każdej chwili możesz poprosić konsultanta o merytoryczne wsparcie w kwestiach poszukiwania i zakupu nieruchomości. Nasi eksperci podpowiedzą Ci na co zwrócić uwagę w ofertach i jak skutecznie negocjować z deweloperem.",
        copyVariant: howSearchWorksCopyVariant
    }
];
